import { render, staticRenderFns } from "./JoinJciMember.vue?vue&type=template&id=34a53bd2"
import script from "./JoinJciMember.vue?vue&type=script&lang=js"
export * from "./JoinJciMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports